import { cva } from 'class-variance-authority';

/**
 * Filter bar class recipes. Ported from the Figma set `Filter bar` (2072:145520), re-read 2026-09-29.
 *
 * The set draws two variants, `Wide` and `Narrow`, and says "Narrow when the container is a phone or
 * a narrow column". A media query would answer for the viewport, so the bar asks its OWN width. It
 * does that with a `ResizeObserver` and a `data-layout` attribute rather than a CSS container query,
 * because `container-type: inline-size` gives the element size containment: in any shrink-to-fit
 * parent (a flex item, an inline-block, a Storybook docs canvas) it collapses to zero width, the bar
 * reads as "narrow", and the search shrinks to a clipped circle. Measuring the element instead
 * degrades to the natural wide layout there. The switch is at 36rem, a code decision: the file draws
 * Wide at 1160 and Narrow at 320 and nothing in between.
 */
export const filterBarRootRecipe = cva(['group/fb w-full']);

export const filterBarRowRecipe = cva([
  // `gap-2` is Figma's `x2`, both between the parts and between wrapped lines.
  'flex flex-wrap items-center gap-2',
  'group-data-[layout=narrow]/fb:flex-col group-data-[layout=narrow]/fb:items-start',
]);

/**
 * The Filters slot. `flex-1` is what carries Clear all and the summary to the right edge in Wide, as
 * the drawing's FILL slot does; `min-w-0` lets it shrink and wrap instead of forcing the row wider.
 */
export const filterBarFiltersRecipe = cva([
  'flex min-w-0 flex-1 flex-wrap items-center gap-2',
  'group-data-[layout=narrow]/fb:w-full group-data-[layout=narrow]/fb:flex-none',
]);

/** The search: the drawn 300px in Wide (no spacing step is that wide), the full width in Narrow. */
export const filterBarSearchRecipe = cva(['w-[300px]', 'group-data-[layout=narrow]/fb:w-full']);

/** The result count. Always mounted so a screen reader is already listening when it changes. */
export const filterBarSummaryRecipe = cva(['text-body-sm text-[var(--foreground-secondary)] empty:hidden']);
